import { Controller } from "@hotwired/stimulus"

// Задел под аналитику воронки. Любой клик по элементу с
// data-analytics-event="имя" отправляем в dataLayer (GTM-совместимо).
// Пока провайдер не подключён — просто накапливаем события в window.dataLayer.
export default class extends Controller {
  connect() {
    this.onClick = this.onClick.bind(this)
    this.element.addEventListener("click", this.onClick)
  }

  disconnect() {
    this.element.removeEventListener("click", this.onClick)
  }

  onClick(event) {
    const target = event.target.closest("[data-analytics-event]")
    if (!target) return

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "funnel",
      action: target.dataset.analyticsEvent,
      href: target.getAttribute("href") || null,
    })
  }
}
